import { VueConstructor } from 'vue';
import Message from './message';

const install = (Vue: VueConstructor, opts = {}) => {
  Vue.component('Message', Message);

  Vue.prototype.$Message = Message;
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  Message
};
